<template>
  <div :class="transition" >
    <div v-if="active" class="loading-happening" role="dialog" >
      <div class="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <slot name="message">
        <span class="loading-happening-message">&nbsp;
          {{ $t('spinnermsg3') }}
          
        </span>
      </slot>
      
    </div>
  </div>
</template>

<script>

  import store from '@/store'

  export default {
    name: 'consent',
    props: {
      active: Boolean,
      // default
      transition: {
        type: String,
        default: 'loading-happening-transition'
      },
      rel: {
        type: String,
        default: 'noopener'
      },
      
    },
    data() {
      return {
        show: undefined
      }
    },
    computed: {
      cookie() {
        return !store.getters.cookie
      }
    },
    beforeMount() {
    //  this.show = this.cookie
    },
    methods: {
      dismiss() {
        this.show = false
  
      },
  
    }
  }
</script>
  <style > 
    $cookieconstent-padding: 1rem 0 !default;
    $cookieconstent-space: .5rem 1rem !default;
    $cookieconstent-position: fixed !default;
    $cookieconstent-background: #ced4da !default;
    $cookieconstent-z-index: 9999 !default;
    $cookieconstent-width: 100% !default;

    $cookieconstent-compliance-padding: .5rem 2rem !default;
    $cookieconstent-compliance-color: #fff !default;
    $cookieconstent-compliance-background: #237afc !default;
    $cookieconstent-compliance-border: 2px solid currentColor !default;

    .loading-happening {
      left: 0;
      right: 0;
      bottom: 0;
     }

    .loading-happening-transition {
    }
 

  .loading-happening {
    position: fixed !important;
    width: 100% !important;
    bottom: 0 !important;
    z-index: 9999 !important;
    width: 100% !important;
    /*padding: 1rem 0 !important;*/
    padding: 5px 16px;
    min-height : 40px;
     display: flex; 
    /*flex-wrap: wrap;*/
    align-items: center;
    justify-content: center;
    background: #0281bc !important;
    color:white;
  }
  .loading-happening-message {
       /* margin: .5rem 1rem !important;*/
       margin: 0;
        white-space: nowrap;
      }

  .loader {
    display: inline-block;
    position: relative;
    align-items: center;
    margin: 0px;
    width: 20px;
    height: 20px;
  }

    .loader div {
 
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 20px;
      height: 20px;
      margin: 0;
      border: 3px solid #74be40;
      border-radius: 50%;
      animation: loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #74be40 transparent transparent transparent;
    }

      .loader div:nth-child(1) {
        animation-delay: -0.45s;
      }

      .loader div:nth-child(2) {
        animation-delay: -0.3s;
      }

      .loader div:nth-child(3) {
        animation-delay: -0.15s;
      }

  @keyframes loader {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
    
</style>